import { render, staticRenderFns } from "./BatchesTable.vue?vue&type=template&id=e80c586e&scoped=true"
import script from "./BatchesTable.vue?vue&type=script&lang=js"
export * from "./BatchesTable.vue?vue&type=script&lang=js"
import style0 from "./BatchesTable.vue?vue&type=style&index=0&id=e80c586e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80c586e",
  null
  
)

export default component.exports